// sagas.js
import { call, put, takeEvery, take, } from 'redux-saga/effects';
import {
  CREATE_USER_REQUEST,
  FETCH_USERS_REQUEST,
  FETCH_USER_TICKETS_REQUEST,
  FETCH_USER_REQUEST,
  UPDATE_USER_REQUEST,
  DELETE_USER_REQUEST,
  CHANGE_PASSWORD_REQUEST,

  createUserSuccess,
  fetchUsersSuccess,
  fetchUserSuccess,
  fetchUserTicketsSuccess,
  updateUserSuccess,
  deleteUserSuccess,
  changePasswordSuccess,

  createUserFailure,
  fetchUsersFailure,
  fetchUserFailure,
  fetchUserTicketsFailure,
  updateUserFailure,
  deleteUserFailure,
  changePasswordFailure,
} from './actions';

import { api } from '../../api';

function* createUserSaga(action) {
  try {
    const response = yield call(api.createUser, action.payload); // Pass the function and the args 
    yield put(createUserSuccess(response.data));
  } catch (error) {
    yield put(createUserFailure(error.message));
  }
}

function* fetchUsersSaga() {
  try {
    console.log("data saga users",);
    const response = yield call(api.getUsers); // Pass the function and the args 
    yield put(fetchUsersSuccess(response.data));
  } catch (error) {
    yield put(fetchUsersFailure(error.message));
  }
}

function* fetchUserSaga(action) {
  try {
    const response = yield call(api.getUser, action.payload); // Pass the function and the args 
    const result = yield put(fetchUserSuccess(response.data));
  } catch (error) {
    yield put(fetchUserFailure(error.message));
  }
}

function* fetchUserTicketsSaga(action) {
  try {
    console.log("data action", action.payload);
    const response = yield call(api.getUserTickets, action.payload); // Pass the function and the args 
    yield put(fetchUserTicketsSuccess(response.data));
  } catch (error) {
    yield put(fetchUserTicketsFailure(error.message));
  }
}

function* updateUserSaga(action) {
  try {
    const { id, data } = action.payload;
    const response = yield call(api.updateUser, id, data); // Pass the function and the args 
    yield put(updateUserSuccess(response.data));
  } catch (error) {
    yield put(updateUserFailure(error.message));
  }
}

function* deleteUserSaga(action) {
  try {
    const response = yield call(api.deleteUser, action.payload); // Pass the function and the args 
    yield put(deleteUserSuccess(response.data));
  } catch (error) {
    yield put(deleteUserFailure(error.message));
  }
}

function* changePasswordSaga(action) {
  try {
    console.log("data saga ChangePassword", action);
    const response = yield call(api.changePassword, action.payload); // Pass the function and the args 
    yield put(changePasswordSuccess(response.data));
  } catch (error) {
    yield put(changePasswordFailure(error.message));
  }
}

export function* watchCreateUser() {
  yield takeEvery(CREATE_USER_REQUEST, createUserSaga);
}

export function* watchFetchUsers() {
  yield takeEvery(FETCH_USERS_REQUEST, fetchUsersSaga);
}

export function* watchFetchUser() {
  yield takeEvery(FETCH_USER_REQUEST, fetchUserSaga);
}

export function* watchFetchUserTickets() {
  yield takeEvery(FETCH_USER_TICKETS_REQUEST, fetchUserTicketsSaga);
}

export function* watchUpdateUser() {
  yield takeEvery(UPDATE_USER_REQUEST, updateUserSaga);
}

export function* watchDeleteUser() {
  yield takeEvery(DELETE_USER_REQUEST, deleteUserSaga);
}

export function* watchChangePassword() {
  yield takeEvery(CHANGE_PASSWORD_REQUEST, changePasswordSaga);
}